import React, { useEffect, useState, useRef } from "react";
import style from "./Account.module.scss";
import CircularProgress from "../../../../CircularProgress/CircularProgress";
import { formattedNumber } from "../../../../FormattedNumber/FormattedNumber";

export const ExternalAccountWrapper = ({
  logo,
  onChange,
  onCheckCashAccount,
  selectedAccount,
  selectedCash,
  getAccountsService,
  account,
  currencyISO,
  disabled,
  onChangeAvailableAccounts,
  error,
  getParameterValue,
  orderSide,
}) => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [requiredBankAccount, setRequiredBankAccount] = useState(false);
  const [showBankAccountBalance, setshowBankAccountBalance] = useState(false);
  const [accountsFetched, setAccountsFetched] = useState(false);
  const prevHolderId = useRef(null);

  useEffect(() => {
    if (account.HolderId && account.AccountId) {
      const getBankAccounts = async () => {

        const holderChanged = prevHolderId.current !== null && prevHolderId.current !== account.HolderId;

        if (holderChanged) {
          onChange(null);
        }
        setLoading(() => true);
        try {
          const { response } = await getAccountsService({
            personId: account.HolderId,
            accountId: account.AccountId,
            orderSide: orderSide,
            orderSide: orderSide,
          });

          setAccounts(() => response.clientBankAccounts || []);
          onChangeAvailableAccounts(response.clientBankAccounts || []);
          setAccountsFetched(() => true);
        } catch (error) {
          console.error("Error getting bank accounts", error);
          setAccountsFetched(() => true);
          setAccountsFetched(() => true);
        } finally {
          setLoading(() => false);
          prevHolderId.current = account.HolderId;
        }
      };
      getBankAccounts();
    }
  }, [account.HolderId, account.AccountId]);


    useEffect(() => {
      getParameterValue && getParameterValue({ ParameterName: "requiredBanksAccounts" },(response) => {
        if (response && response.SdtParametersData.ParameterNumericValue == 1) {
            setRequiredBankAccount(true)
          }
        });
      
      getParameterValue && getParameterValue({ ParameterName: "showBankAccountBalance" },(response) => {
        if (response && response.SdtParametersData.ParameterNumericValue == 1) {
          setshowBankAccountBalance(true)
          }
        });
    }, [])

  const handleCheckAccount = (accountNumber) => {
    if (selectedAccount === accountNumber) {
      onChange(null);
    } else {
      onChange(accountNumber);
    }
  };

  return (
    accounts.filter((account) => account.currencyISO === currencyISO).length > 0 ? (
      <div key="accWrapper" className={`${style.bankAccounts} ${error ? style.error : ""}`}>
        {loading ? (
          <CircularProgress />
        ) : (
          <React.Fragment>
            {accounts
              .filter((account) => account.currencyISO === currencyISO)
              .map((account) => {
                return (
                  <div
                    className={`${style.item} ${selectedAccount === account.number ? style.selected : null} ${disabled ? style.disabled : null
                      }`}
                    key={account.number}
                    onClick={disabled ? () => { } : () => handleCheckAccount(account.number)}
                  >
                    <div className={style.logo}>
                      <img src={`${logo}`} />
                    </div>
                    <div className={style.info}>
                      <span>N° </span>
                      <span className={style.data}>{account.number}</span>
                      <br />
                      <span>Currency </span>
                      <span className={style.data}>{account.currencyISO}</span>
                      <br />
                      <span>Type </span>
                      <span className={style.data}>{account.Type}</span>
                      {showBankAccountBalance && account.availableBalance &&(
                        <React.Fragment>
                          <br />
                          <span>Balance </span>
                          <span className={style.data}>{formattedNumber(account.availableBalance, "price")}</span>
                        </React.Fragment>
                      )}
                    </div>
                    <div className={style.checkbox}>
                      {selectedAccount === account.number ? (
                        <i className="fa fa-check-square-o" aria-hidden="true" />
                      ) : (
                        <i className="fa fa-square-o" aria-hidden="true" />
                      )}
                    </div>
                  </div>
                );
              })}
            
            { !requiredBankAccount && (
              <React.Fragment>
                <hr/>
                <div
                  className={`${style.cash} ${selectedCash ? style.selected : null} ${disabled ? style.disabled : null
                    }`}
                  onClick={disabled ? () => { } : () => onCheckCashAccount()}
                >
                  <div>
                    <span>Use local cash account</span>
                  </div>
                  <div className={style.checkbox}>
                    {selectedCash ? (
                      <i className="fa fa-check-square-o" aria-hidden="true" />
                    ) : (
                      <i className="fa fa-square-o" aria-hidden="true" />
                    )}
                  </div>
                </div>
            </React.Fragment>
            )}
            
            { !requiredBankAccount && (
              <React.Fragment>
                <hr/>
                <div
                  className={`${style.cash} ${selectedCash ? style.selected : null} ${disabled ? style.disabled : null
                    }`}
                  onClick={disabled ? () => { } : () => onCheckCashAccount()}
                >
                  <div>
                    <span>Use local cash account</span>
                  </div>
                  <div className={style.checkbox}>
                    {selectedCash ? (
                      <i className="fa fa-check-square-o" aria-hidden="true" />
                    ) : (
                      <i className="fa fa-square-o" aria-hidden="true" />
                    )}
                  </div>
                </div>
            </React.Fragment>
            )}
          </React.Fragment>
        )}
        {error && <span className={style.errorText}>{error}</span>}
      </div>
    ) : (requiredBankAccount && !loading && accountsFetched) ? (
      <div key="accWrapper" className={`${style.bankAccounts} ${style.error}`}>
        <span className={style.errorText}>No bank accounts available</span>
      </div>
    ) : null
  );
};